import { Filters } from '../../Filters';
export function getShift(spectrum) {
    let shift = { x: 0, y: 0 };
    if (spectrum?.filters) {
        for (const filter of spectrum.filters) {
            if (filter.name === Filters.shift2DX.id) {
                shift.x = filter?.flag ? filter.value.shift : 0;
            }
            if (filter.name === Filters.shift2DY.id) {
                shift.y = filter?.flag ? filter.value.shift : 0;
            }
        }
    }
    return shift;
}
//# sourceMappingURL=getShift.js.map